import { createRouter, createWebHistory } from 'vue-router'
import { AuthService } from '@/services/auth'
import { authStore } from '@/store/auth'
import DashboardLayout from '../components/DashboardLayout.vue'
import LoginView from '../views/LoginView.vue'
import RegisterView from '../views/RegisterView.vue'
import PaymentView from '../views/PaymentView.vue'
import ForgotPasswordView from '../views/ForgotPasswordView.vue'
import AgentsView from '../views/AgentsView.vue'
import DepartmentsView from '../views/DepartmentsView.vue'
import MessagingView from '../views/MessagingView.vue'
import WhatsAppView from '../views/WhatsAppView.vue'
import CompanyProfileView from '../views/CompanyProfileView.vue'
import QuickRepliesView from '../views/QuickRepliesView.vue'
import CompanyLeadsView from '../views/CompanyLeadsView.vue'
import TodoView from '../views/TodoView.vue'
import CustomersView from '../views/CustomersView.vue'
import ProductsServicesView from '../views/ProductsServicesView.vue'
import AppointmentsView from '../views/AppointmentsView.vue'
import AppointmentsReportView from '../views/AppointmentsReportView.vue'
import EscalationsView from '../views/EscalationsView.vue'
import AIAnalysisView from '../views/AIAnalysisView.vue'
import AgentReportView from '../views/AgentReportView.vue'
import WhatsAppSettingsView from '../views/WhatsAppSettingsView.vue'
import LeadsView from '../views/LeadsView.vue'
import PaymentsView from '../views/PaymentsView.vue'
import PaymentSuccessView from '../views/PaymentSuccessView.vue'
import PaymentFailedView from '../views/PaymentFailedView.vue'
import RenewSubscriptionView from '../views/RenewSubscriptionView.vue'
import CRMIntegrationView from '../views/CRMIntegrationView.vue'
import CRMCallbackView from '../views/CRMCallbackView.vue'
import OdooIntegrationView from '../views/OdooIntegrationView.vue'
import GoogleIntegrationView from '../views/GoogleIntegrationView.vue'
import MicrosoftIntegrationView from '../views/MicrosoftIntegrationView.vue'
import TotpSettingsView from '../views/TotpSettingsView.vue'
import MessengerIntegrationView from '../views/MessengerIntegrationView.vue'
import MessengerView from '../views/MessengerView.vue'
import TelegramView from '../views/TelegramView.vue'
import TelegramIntegrationView from '../views/TelegramIntegrationView.vue'
import WhatsAppTutorialView from '../views/WhatsAppTutorialView.vue'
import WhatsAppTemplatesView from '../views/WhatsAppTemplatesView.vue'
import WhatsAppBroadcastView from '../views/WhatsAppBroadcastView.vue'
import WhatsAppBroadcastRecipientsView from '../views/WhatsAppBroadcastRecipientsView.vue'
import MetaIntegrationView from '../views/MetaIntegrationView.vue'
import WhatsAppProfileView from '../views/WhatsAppProfileView.vue'
import AgentLoginView from '../views/AgentLoginView.vue'
import AgentDashboardView from '../views/AgentDashboardView.vue'
import AgentLeadsView from '../views/AgentLeadsView.vue'
import AgentWhatsAppView from '../views/AgentWhatsAppView.vue'
import AgentPerformanceView from '../views/AgentPerformanceView.vue'
import AgentKickedView from '../views/AgentKickedView.vue'
import UserKickedView from '../views/UserKickedView.vue'
import EmbeddedSignupCallbackView from '../views/EmbeddedSignupCallbackView.vue'
import WhatsAppFlowsView from '../views/WhatsAppFlowsView.vue'
import RestaurantSettingsView from '../views/RestaurantSettingsView.vue'
import RestaurantCategoriesView from '../views/RestaurantCategoriesView.vue'
import RestaurantMenuItemsView from '../views/RestaurantMenuItemsView.vue'
import RestaurantOrdersView from '../views/RestaurantOrdersView.vue'
import RestaurantRidersView from '../views/RestaurantRidersView.vue'
import AdminFinancialDashboardView from '../views/AdminFinancialDashboardView.vue'
import WhatsAppAccountsView from '../views/WhatsAppAccountsView.vue'
import WhatsAppProvisioningView from '../views/WhatsAppProvisioningView.vue'
import FlowBuilderView from '../views/FlowBuilderView.vue'
import CustomFlowsView from '../views/CustomFlowsView.vue'
import DemoDashboardView from '../views/DemoDashboardView.vue'
import DemoWhatsAppView from '../views/DemoWhatsAppView.vue'
import DemoCustomersView from '../views/DemoCustomersView.vue'
import DemoDepartmentsView from '../views/DemoDepartmentsView.vue'
import DemoAgentsView from '../views/DemoAgentsView.vue'
import DemoAIAnalysisView from '../views/DemoAIAnalysisView.vue'
import DemoMessagingView from '../views/DemoMessagingView.vue'
import DemoLeadsView from '../views/DemoLeadsView.vue'
import DemoProductsServicesView from '../views/DemoProductsServicesView.vue'
import DemoAppointmentsView from '../views/DemoAppointmentsView.vue'

const routes = [
  {
    path: '/login',
    name: 'login',
    component: LoginView,
    meta: { requiresGuest: true }
  },
  {
    path: '/register',
    name: 'register',
    component: RegisterView,
    meta: { requiresGuest: true }
  },
  {
    path: '/payment',
    name: 'payment',
    component: PaymentView,
    meta: { allowBoth: true, skipSubscriptionCheck: true }
  },
  {
    path: '/forgot-password',
    name: 'forgot-password',
    component: ForgotPasswordView,
    meta: { requiresGuest: true }
  },
  {
    path: '/',
    name: 'dashboard',
    component: DashboardLayout,
    meta: { requiresAuth: true }
  },
  {
    path: '/agents',
    name: 'agents',
    component: AgentsView,
    meta: { requiresAuth: true }
  },
  {
    path: '/departments',
    name: 'departments',
    component: DepartmentsView,
    meta: { requiresAuth: true }
  },
  {
    path: '/messages',
    name: 'messages',
    component: MessagingView,
    meta: { requiresAuth: true }
  },
  {
    path: '/messenger',
    name: 'messenger',
    component: MessengerView,
    meta: { requiresAuth: true }
  },
  {
    path: '/telegram',
    name: 'telegram',
    component: TelegramView,
    meta: { requiresAuth: true, requiresAdmin: true }
  },
  {
    path: '/whatsapp',
    name: 'whatsapp',
    component: WhatsAppView,
    meta: { requiresAuth: true, allowAgents: true }
  },
  {
    path: '/company-profile',
    name: 'company-profile',
    component: CompanyProfileView,
    meta: { requiresAuth: true }
  },
  {
    path: '/quick-replies',
    name: 'quick-replies',
    component: QuickRepliesView,
    meta: { requiresAuth: true }
  },
  {
    path: '/company-leads',
    name: 'company-leads',
    component: CompanyLeadsView,
    meta: { requiresAuth: true }
  },
  {
    path: '/todo',
    name: 'todo',
    component: TodoView,
    meta: { requiresAuth: true }
  },
  {
    path: '/customers',
    name: 'customers',
    component: CustomersView,
    meta: { requiresAuth: true, ownerOnly: true }
  },
  {
    path: '/products-services',
    name: 'products-services',
    component: ProductsServicesView,
    meta: { requiresAuth: true }
  },
  {
    path: '/appointments',
    name: 'appointments',
    component: AppointmentsView,
    meta: { requiresAuth: true }
  },
  {
    path: '/reports-appointments',
    name: 'appointments-report',
    component: AppointmentsReportView,
    meta: { requiresAuth: true }
  },
  {
    path: '/restaurant-dashboard',
    name: 'restaurant-dashboard',
    component: () => import('../views/RestaurantDashboardView.vue'),
    meta: { requiresAuth: true, requiresAdmin: true }
  },
  {
    path: '/restaurant-settings',
    name: 'restaurant-settings',
    component: RestaurantSettingsView,
    meta: { requiresAuth: true, requiresAdmin: true }
  },
  {
    path: '/restaurant-categories',
    name: 'restaurant-categories',
    component: RestaurantCategoriesView,
    meta: { requiresAuth: true, requiresAdmin: true }
  },
  {
    path: '/restaurant-menu-items',
    name: 'restaurant-menu-items',
    component: RestaurantMenuItemsView,
    meta: { requiresAuth: true, requiresAdmin: true }
  },
  {
    path: '/restaurant-orders',
    name: 'restaurant-orders',
    component: RestaurantOrdersView,
    meta: { requiresAuth: true, requiresAdmin: true }
  },
  {
    path: '/restaurant-riders',
    name: 'restaurant-riders',
    component: RestaurantRidersView,
    meta: { requiresAuth: true, requiresAdmin: true }
  },
  {
    path: '/admin/financial',
    name: 'admin-financial',
    component: AdminFinancialDashboardView,
    meta: { requiresAuth: true, requiresAdmin: true }
  },
  {
    path: '/admin/whatsapp-accounts',
    name: 'admin-whatsapp-accounts',
    component: WhatsAppAccountsView,
    meta: { requiresAuth: true, requiresAdmin: true }
  },
  {
    path: '/admin/whatsapp-provisioning',
    name: 'admin-whatsapp-provisioning',
    component: WhatsAppProvisioningView,
    meta: { requiresAuth: true, requiresAdmin: true }
  },
  {
    path: '/escalations',
    name: 'escalations',
    component: EscalationsView,
    meta: { requiresAuth: true }
  },
  {
    path: '/ai-analysis',
    name: 'ai-analysis',
    component: AIAnalysisView,
    meta: { requiresAuth: true }
  },
  {
    path: '/agent-report/:agentId',
    name: 'agent-report',
    component: AgentReportView,
    meta: { requiresAuth: true }
  },
  {
    path: '/dashboard2',
    redirect: '/',
    meta: { requiresAuth: true }
  },
  {
    path: '/whatsapp-settings',
    name: 'whatsapp-settings',
    component: WhatsAppSettingsView,
    meta: { requiresAuth: true }
  },
  {
    path: '/leads',
    name: 'leads',
    component: LeadsView,
    meta: { requiresAuth: true, allowAgents: true }
  },
  {
    path: '/payments',
    name: 'payments',
    component: PaymentsView,
    meta: { requiresAuth: true, skipSubscriptionCheck: true }
  },
  {
    path: '/renew-subscription',
    name: 'renew-subscription',
    component: RenewSubscriptionView,
    meta: { requiresAuth: true, skipSubscriptionCheck: true }
  },
  {
    path: '/success',
    name: 'payment-success',
    component: PaymentSuccessView,
    meta: { allowBoth: true, skipSubscriptionCheck: true }
  },
  {
    path: '/renewal-success',
    name: 'renewal-success',
    component: PaymentSuccessView,
    meta: { allowBoth: true, skipSubscriptionCheck: true }
  },
  {
    path: '/payment-failed',
    name: 'payment-failed',
    component: PaymentFailedView,
    meta: { allowBoth: true, skipSubscriptionCheck: true }
  },
  {
    path: '/zoho-integration',
    name: 'zoho-integration',
    component: CRMIntegrationView,
    meta: { requiresAuth: true }
  },
  {
    path: '/crm-callback',
    name: 'crm-callback',
    component: CRMCallbackView,
    meta: { requiresAuth: true }
  },
  {
    path: '/odoo-integration',
    name: 'odoo-integration',
    component: OdooIntegrationView,
    meta: { requiresAuth: true }
  },
  {
    path: '/settings/google',
    name: 'google-integration',
    component: GoogleIntegrationView,
    meta: { requiresAuth: true }
  },
  {
    path: '/settings/microsoft',
    name: 'microsoft-integration',
    component: MicrosoftIntegrationView,
    meta: { requiresAuth: true }
  },
  {
    path: '/settings/security',
    name: 'security-settings',
    component: TotpSettingsView,
    meta: { requiresAuth: true }
  },
  {
    path: '/settings/messenger',
    name: 'messenger-integration',
    component: MessengerIntegrationView,
    meta: { requiresAuth: true, requiresAdmin: true }
  },
  {
    path: '/settings/telegram',
    name: 'telegram-integration',
    component: TelegramIntegrationView,
    meta: { requiresAuth: true, requiresAdmin: true }
  },
  {
    path: '/tutorials/whatsapp',
    name: 'whatsapp-tutorial',
    component: WhatsAppTutorialView,
    meta: { requiresAuth: true }
  },
  {
    path: '/whatsapp-templates',
    name: 'whatsapp-templates',
    component: WhatsAppTemplatesView,
    meta: { requiresAuth: true }
  },
  {
    path: '/whatsapp-broadcast',
    name: 'whatsapp-broadcast',
    component: WhatsAppBroadcastView,
    meta: { requiresAuth: true, requiresBroadcastAccess: true }
  },
  {
    path: '/whatsapp-broadcast/:id',
    name: 'whatsapp-broadcast-recipients',
    component: WhatsAppBroadcastRecipientsView,
    meta: { requiresAuth: true, requiresBroadcastAccess: true }
  },
  {
    path: '/meta-integration',
    name: 'meta-integration',
    component: MetaIntegrationView,
    meta: { requiresAuth: true }
  },
  {
    path: '/whatsapp-profile',
    name: 'whatsapp-profile',
    component: WhatsAppProfileView,
    meta: { requiresAuth: true }
  },
  {
    path: '/whatsapp-embedded-signup-callback',
    name: 'whatsapp-embedded-signup-callback',
    component: EmbeddedSignupCallbackView,
    meta: { allowBoth: true } // No auth required - this is a callback page
  },
  {
    path: '/whatsapp-flows',
    name: 'whatsapp-flows',
    component: WhatsAppFlowsView,
    meta: { requiresAuth: true }
  },
  {
    path: '/custom-flows',
    name: 'custom-flows',
    component: CustomFlowsView,
    meta: { requiresAuth: true, requiresAdmin: true }
  },
  {
    path: '/flow-builder/:id?',
    name: 'flow-builder',
    component: FlowBuilderView,
    meta: { requiresAuth: true, requiresAdmin: true }
  },
  // Demo Routes (No authentication required)
  {
    path: '/demo',
    name: 'demo',
    component: DemoDashboardView,
    meta: { allowBoth: true }
  },
  {
    path: '/demo/whatsapp',
    name: 'demo-whatsapp',
    component: DemoWhatsAppView,
    meta: { allowBoth: true }
  },
  {
    path: '/demo/customers',
    name: 'demo-customers',
    component: DemoCustomersView,
    meta: { allowBoth: true }
  },
  {
    path: '/demo/departments',
    name: 'demo-departments',
    component: DemoDepartmentsView,
    meta: { allowBoth: true }
  },
  {
    path: '/demo/agents',
    name: 'demo-agents',
    component: DemoAgentsView,
    meta: { allowBoth: true }
  },
  {
    path: '/demo/ai-analysis',
    name: 'demo-ai-analysis',
    component: DemoAIAnalysisView,
    meta: { allowBoth: true }
  },
  {
    path: '/demo/messages',
    name: 'demo-messages',
    component: DemoMessagingView,
    meta: { allowBoth: true }
  },
  {
    path: '/demo/leads',
    name: 'demo-leads',
    component: DemoLeadsView,
    meta: { allowBoth: true }
  },
  {
    path: '/demo/products-services',
    name: 'demo-products-services',
    component: DemoProductsServicesView,
    meta: { allowBoth: true }
  },
  {
    path: '/demo/appointments',
    name: 'demo-appointments',
    component: DemoAppointmentsView,
    meta: { allowBoth: true }
  },
  // Agent Routes
  {
    path: '/agent-login',
    name: 'agent-login',
    component: AgentLoginView,
    meta: { requiresAgentGuest: true }
  },
  {
    path: '/agent-dashboard',
    name: 'agent-dashboard',
    component: AgentDashboardView,
    meta: { requiresAgentAuth: true }
  },
  {
    path: '/agent/leads',
    name: 'agent-leads',
    component: AgentLeadsView,
    meta: { requiresAgentAuth: true }
  },
  {
    path: '/agent/whatsapp',
    name: 'agent-whatsapp',
    component: AgentWhatsAppView,
    meta: { requiresAgentAuth: true }
  },
  {
    path: '/agent/performance',
    name: 'agent-performance',
    component: AgentPerformanceView,
    meta: { requiresAgentAuth: true }
  },
  {
    path: '/agent/kicked',
    name: 'agent-kicked',
    component: AgentKickedView
    // No auth guard — must be reachable even when logged out
  },
  {
    path: '/user/kicked',
    name: 'user-kicked',
    component: UserKickedView
    // No auth guard — must be reachable even when logged out
  }
]

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes
})

router.beforeEach(async (to, from, next) => {
  try {
    const isAuthenticated = AuthService.isAuthenticated()
    const isAgentAuthenticated = !!localStorage.getItem('agent_token')
    const user = JSON.parse(localStorage.getItem('user') || '{}')
    const isAdmin = user.role_id === 1
    const agentData = JSON.parse(localStorage.getItem('agent_data') || '{}')
    const isMarketingAgent = isAgentAuthenticated && (agentData.agent_role_name === 'Marketing' || parseInt(agentData.agent_role_id) === 3)

    // Handle admin-only routes
    if (to.meta.requiresAdmin && !isAdmin) {
      console.log('Admin access required, redirecting to dashboard')
      next('/')
      return
    }

    // Handle owner-only routes (block agents, but allow Marketing agents through)
    if (to.meta.ownerOnly && isAgentAuthenticated && !isMarketingAgent) {
      console.log('Owner-only page, redirecting agent to dashboard')
      next('/agent-dashboard')
      return
    }

    // Block Marketing agents from regular agent-only routes
    if (to.meta.requiresAgentAuth && isMarketingAgent) {
      console.log('Marketing agent redirected from agent route to templates')
      next('/whatsapp-templates')
      return
    }

    // Handle WhatsApp Broadcast access restriction (plan_id 4 or 5 blocked)
    if (to.meta.requiresBroadcastAccess && isAuthenticated && !isAgentAuthenticated) {
      // Ensure subscription is checked
      if (!authStore.subscriptionChecked && !authStore.subscriptionChecking) {
        await authStore.checkSubscription()
      }

      if (!authStore.canAccessBroadcast()) {
        console.log('WhatsApp Broadcast access restricted, redirecting to payments')
        next('/payments')
        return
      }
    }

    // Handle agent authentication
    if (to.meta.requiresAgentAuth && !isAgentAuthenticated) {
      console.log('Agent authentication required, redirecting to agent login')
      next('/agent-login')
      return
    } else if (to.meta.requiresAgentGuest && isAgentAuthenticated) {
      console.log('Agent already authenticated, redirecting to agent dashboard')
      next('/agent-dashboard')
      return
    }

    // Check subscription expiry for authenticated owner routes
    // Skip check for: payment flow pages, agent routes, guest routes, and unauthenticated users
    const isOwnerAuthenticated = isAuthenticated && !isAgentAuthenticated
    const skipSubscriptionCheck = to.meta.skipSubscriptionCheck ||
      to.meta.requiresAgentAuth ||
      to.meta.requiresAgentGuest ||
      to.meta.requiresGuest ||
      to.path.startsWith('/agent') ||
      to.path.startsWith('/demo')

    if (isOwnerAuthenticated && !skipSubscriptionCheck) {
      // Only fetch once per session; reuse cached result on subsequent navigations
      if (!authStore.subscriptionChecked && !authStore.subscriptionChecking) {
        await authStore.checkSubscription()
      }

      if (authStore.subscriptionExpired) {
        console.log('Subscription expired, redirecting to renew-subscription')
        next('/renew-subscription')
        return
      }
    }

    if (to.meta.requiresAuth) {
      // Allow agents on pages marked with allowAgents
      if (to.meta.allowAgents && isAgentAuthenticated) {
        console.log('Agent accessing shared page:', to.path)
        next()
      } else if (isMarketingAgent) {
        // Marketing agents can access requiresAuth pages (templates, broadcast, customers)
        console.log('Marketing agent accessing page:', to.path)
        next()
      } else if (!isAuthenticated) {
        console.log('Authentication required, redirecting to login')
        next('/login')
      } else {
        next()
      }
    } else if (to.meta.requiresGuest && isAuthenticated) {
      console.log('User already authenticated, redirecting to dashboard')
      next('/')
    } else if (to.meta.allowBoth) {
      // Allow both authenticated and non-authenticated users
      next()
    } else {
      next()
    }
  } catch (error) {
    console.error('Router guard error:', error)
    // If there's any error, clear storage and go to login
    localStorage.clear()
    sessionStorage.clear()
    next('/login')
  }
})

export default router
